module.exports = __webpack_public_path__ + "img/team_4_index_small.e96046f1.png";